const ConfirmDeleteModal = ({
                              title,
                              description,
                              onConfirm,
                              onCancel
                            }) => {
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/40">
      <div className="bg-white w-80 rounded-lg p-4">
        <h3 className="font-semibold text-sm">{title}</h3>
        <p className="text-xs text-gray-600 mt-2">{description}</p>

        <div className="flex justify-end gap-3 mt-4">
          <button
            onClick={onCancel}
            className="text-sm text-gray-600"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="text-sm text-white bg-BluntRed px-3 py-1 rounded"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
